// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tariff Importer Styles */
.tariff-importer {
  background-color: var(--bg-white);
  padding: 2.5rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  margin-bottom: 3rem;
}

.tariff-importer h3 {
  color: var(--primary-dark-blue);
  margin-bottom: 1.5rem;
  text-align: center;
}

.import-methods {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  justify-content: center;
}

.method-btn {
  padding: 0.8rem 2rem;
  border: 2px solid var(--button-medium-blue);
  background-color: var(--bg-white);
  color: var(--button-medium-blue);
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.method-btn:hover {
  background-color: var(--section-light-gray);
}

.method-btn.active {
  background-color: var(--button-medium-blue);
  color: var(--bg-white);
}

.manual-import,
.csv-import {
  margin-top: 2rem;
}

.manual-import p,
.csv-import p {
  margin-bottom: 1rem;
  color: var(--text-dark-gray);
}

.format-example {
  background-color: var(--section-light-gray);
  padding: 1rem;
  border-radius: 5px;
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  border-right: 3px solid var(--button-medium-blue);
}

.import-textarea {
  width: 100%;
  padding: 1rem;
  border: 2px solid var(--section-light-gray);
  border-radius: 5px;
  font-size: 1rem;
  font-family: inherit;
  margin-bottom: 1rem;
  min-height: 200px;
  resize: vertical;
}

.import-textarea:focus {
  outline: none;
  border-color: var(--button-medium-blue);
}

.file-input {
  width: 100%;
  padding: 1rem;
  border: 2px dashed var(--button-medium-blue);
  border-radius: 5px;
  background-color: var(--section-light-gray);
  cursor: pointer;
  margin-bottom: 1rem;
}

.file-name {
  color: var(--button-medium-blue);
  font-weight: 600;
  margin-top: 0.5rem;
}

@media (max-width: 768px) {
  .import-methods {
    flex-direction: column;
  }

  .method-btn {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/TariffImporter.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,iCAAiC;EACjC,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;EAC3C,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,4CAA4C;EAC5C,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Tariff Importer Styles */\n.tariff-importer {\n  background-color: var(--bg-white);\n  padding: 2.5rem;\n  border-radius: 10px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);\n  margin-bottom: 3rem;\n}\n\n.tariff-importer h3 {\n  color: var(--primary-dark-blue);\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.import-methods {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  justify-content: center;\n}\n\n.method-btn {\n  padding: 0.8rem 2rem;\n  border: 2px solid var(--button-medium-blue);\n  background-color: var(--bg-white);\n  color: var(--button-medium-blue);\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.method-btn:hover {\n  background-color: var(--section-light-gray);\n}\n\n.method-btn.active {\n  background-color: var(--button-medium-blue);\n  color: var(--bg-white);\n}\n\n.manual-import,\n.csv-import {\n  margin-top: 2rem;\n}\n\n.manual-import p,\n.csv-import p {\n  margin-bottom: 1rem;\n  color: var(--text-dark-gray);\n}\n\n.format-example {\n  background-color: var(--section-light-gray);\n  padding: 1rem;\n  border-radius: 5px;\n  font-family: 'Courier New', monospace;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n  border-right: 3px solid var(--button-medium-blue);\n}\n\n.import-textarea {\n  width: 100%;\n  padding: 1rem;\n  border: 2px solid var(--section-light-gray);\n  border-radius: 5px;\n  font-size: 1rem;\n  font-family: inherit;\n  margin-bottom: 1rem;\n  min-height: 200px;\n  resize: vertical;\n}\n\n.import-textarea:focus {\n  outline: none;\n  border-color: var(--button-medium-blue);\n}\n\n.file-input {\n  width: 100%;\n  padding: 1rem;\n  border: 2px dashed var(--button-medium-blue);\n  border-radius: 5px;\n  background-color: var(--section-light-gray);\n  cursor: pointer;\n  margin-bottom: 1rem;\n}\n\n.file-name {\n  color: var(--button-medium-blue);\n  font-weight: 600;\n  margin-top: 0.5rem;\n}\n\n@media (max-width: 768px) {\n  .import-methods {\n    flex-direction: column;\n  }\n\n  .method-btn {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
